"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("./..");
const dnn_1 = require("./dnn");
class BNN extends dnn_1.DNN {
    constructor(opt) {
        super(opt);
    }
    initializeModelAsFreshInstance(opt) {
        super.initializeModelAsFreshInstance(opt);
        this.initializeHiddenLayerStds(opt);
    }
    initializeHiddenLayerStds(opt) {
        this.hiddenStd = new Array(this.architecture.hiddenUnits.length);
        for (let i = 0; i < this.architecture.hiddenUnits.length; i++) {
            this.hiddenStd[i] = new __1.Mat(this.architecture.hiddenUnits[i], 1);
        }
        for (let i = 0; i < this.architecture.hiddenUnits.length; i++) {
            __1.Utils.fillRandn(this.hiddenStd[i].w, 0, 0.001);
        }
    }
    specificForwardpass(state) {
        const activations = this.computeHiddenActivations(state);
        for (let i = 0; i < this.architecture.hiddenUnits.length; i++) {
            activations[i] = this.graph.gauss(activations[i], this.hiddenStd[i]);
        }
        return activations;
    }
}
exports.BNN = BNN;
//# sourceMappingURL=bnn.js.map